/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EditActorResult {
  Error = 0,
  Success = 1,
  InvalidActor = 2,
  InvalidCompany = 3,
  InvalidCountryCode = 4,
  RequestValidationFailed = 5,
  NoContactForDeclarant = 6,
  ErrorAddingComment = 7,
}
